<script>
import { MdsButton } from "@mds/button";
import MdsForm from "@mds/form";
import MdsSelect from "@mds/select";
import MdsFieldset from "@mds/fieldset";
import AdlRangeSlider from "../range-slider/RangeSlider.vue";
import MdsLoader from "@mds/loader";
import AdlDataList from "../DataList/DataList.vue";
import MdsSwitch from "@mds/switch";
import AdlMonthPicker from "../MonthPicker/MonthPicker.vue";
import AdlCardDropdown from "../CardDropdown/CardDropdown.vue";
import MdsIcon from "@mds/icon";
import { MdsTag, MdsTagContainer } from "@mds/tag";
import AdlInputFormat from "../input-format/InputFormat.vue";
import AdlEditableInput from "../editable-input/EditableInput.vue";
import AdlMultiplePopOver from "../multiple-pop-over/MultiplePopOver.vue";
import MdsProfileImage from "@mds/profile-image";
import MdsTooltip from "@mds/tooltip";

export default {
  name: "AdlExpandableCard",
  props: {
    data: {
      type: Object,
    },

    loading: {
      type: Boolean,
      default: false,
    },

    size: {
      type: String,
      default: "medium",
    },
  },
  data() {
    return {
      form: Object.assign({}, this.data),
      isexpand: true,
      toggleRangeTT: false,
    };
  },
  components: {
    MdsButton,
    MdsForm,
    MdsSelect,
    MdsFieldset,
    MdsLoader,
    AdlRangeSlider,
    MdsSwitch,
    AdlDataList,
    AdlMonthPicker,
    AdlCardDropdown,
    MdsIcon,
    MdsTag,
    MdsTagContainer,
    AdlInputFormat,
    AdlEditableInput,
    AdlMultiplePopOver,
    MdsProfileImage,
    MdsTooltip,
  },
  methods: {
    inputChange() {
      this.$emit("OnChange", this.form);
    },
    ListItemChange() {
      this.$emit("OnChange", this.form);
    },
    IsHide(ishide) {
      const obj = {};
      obj[this.$style["hide-element"]] = !ishide;
      return obj;
    },
    EditData(editabletext, index, event, EditState) {
      this.form.elements[index].EditState = EditState;
      if (editabletext == true) {
        this.form.elements[index].ShowValue = false;
      } else {
        this.$emit("edit", event);
      }
    },
    Onchangedata() {},
    refreshValue(data) {
      this.$emit("refresh", data);
    },
    CancelValue(index) {
      this.form.elements[index].EditState = false;
      this.form.elements[index].ShowValue = true;
      this.$emit("cancel");
    },
    SaveValue($event, index) {
      this.form.elements[index].value = $event;
      this.form.elements[index].ShowValue = true;
      this.form.elements[index].EditState = false;
      this.$emit("OnChange", this.form);
    },
    ExpandIcon() {
      return this.isexpand ? "angle-double-up" : "angle-double-down";
    },
    Expandclick() {
      this.isexpand = !this.isexpand;
    },
  },
  watch: {
    data(newObj, oldObj) {
      this.form = Object.assign({}, newObj);
    },
  },
};
</script>

<template>
  <nav :class="$style['GroupWrap']">
    <div :class="[$style['mca-components-ui__editable-form']]">
      <div>
        <mds-fieldset :disabled="loading" hidden-legend>
          <div
            v-for="format in form.groupFormat"
            v-if="!isexpand ? format.ShowOnMinimise : true"
            :class="[$style['cfSet'], $style[format.class]]"
          >
            <div v-if="format.name && isexpand" :class="$style['group-title']">
              {{ format.name }}
            </div>
            <template
              v-if="isexpand || form.elements[groupElement].showOnMinimise"
              v-for="groupElement in format.element"
            >
              <div
                v-if="
                  form.elements[groupElement].displayType === 'carddropdown'
                "
              >
                <div
                  :class="[
                    $style['mds-card-image'],
                    $style['cf-card-image-engagement'],
                    $style['group-data-img'],
                  ]"
                >
                  <div :class="[$style['cf-card-profileWraper']]">
                    <mds-profile-image
                      :src="form.elements[groupElement].imagepath"
                      :height="form.elements[groupElement].imageheight"
                      :width="form.elements[groupElement].imagewidth"
                      alt="Author Photo"
                    ></mds-profile-image>
                  </div>
                  <div :class="$style['mds-card-caption']">
                    <div>
                      <div
                        :class="[
                          $style['mds-card__title'],
                          $style['cf-card-title-engagement'],
                        ]"
                      >
                        <slot>{{ form.elements[groupElement].title }}</slot>
                      </div>
                    </div>
                    <div v-if="form.elements[groupElement].options.length > 1">
                      <adl-multiple-pop-over
                        :options="form.elements[groupElement].options"
                        v-model="form.elements[groupElement].value"
                        @change="ListItemChange()"
                      ></adl-multiple-pop-over>
                    </div>
                    <div v-else>
                      {{ form.elements[groupElement].options[0].text }}
                    </div>
                  </div>
                </div>
              </div>

              <div
                :class="[$style['dataListGroup'], $style['group-data']]"
                v-if="
                  form.elements[groupElement].displayType === 'editableLabel'
                "
              >
                <div style="display: flex; justify-content: space-between">
                  <div style="display: flex">
                    <div :class="$style['boldfont']">
                      {{ form.elements[groupElement].name }}
                    </div>
                    <div
                      v-if="
                        form.elements[groupElement].EditState
                          ? !form.elements[groupElement].EditState
                          : true
                      "
                    >
                      : {{ form.elements[groupElement].text }}
                    </div>
                  </div>
                  <div :class="$style['innerlabel']" style="display: flex">
                    <div style="display: flex; float: right">
                      <div
                        v-if="
                          form.elements[groupElement].EditState
                            ? !form.elements[groupElement].EditState
                            : true
                        "
                      >
                        <div :class="$style['extratag']" href="#">
                          <mds-tag
                            v-if="form.elements[groupElement].HasTag"
                            on-black
                            :class="[
                              $style['cf-tag-inner'],
                              $style['dataListTag'],
                            ]"
                          >
                            {{ form.elements[groupElement].TagText }}
                          </mds-tag>
                        </div>
                      </div>
                      <div v-if="form.elements[groupElement].HasEditButton">
                        <adl-editable-input
                          :isDisabled="false"
                          v-model="form.elements[groupElement].value"
                          :value="form.elements[groupElement].value"
                          :cancelText="form.elements[groupElement].cancelText"
                          :saveText="form.elements[groupElement].saveText"
                          :isAllowOnlyNumber="
                            form.elements[groupElement].isAllowOnlyNumber
                          "
                          :AllowOnlyDecimalTill="
                            form.elements[groupElement].AllowOnlyDecimalTill
                          "
                          :maxlength="form.elements[groupElement].maxlength"
                          :maxvalue="form.elements[groupElement].maxvalue"
                          :minvalue="form.elements[groupElement].minvalue"
                          :divstyle="form.elements[groupElement].style"
                          microcopyBelow=""
                          :ShowEditTextBox="
                            form.elements[groupElement].ShowEditTextBox
                          "
                          :currencyFormat="
                            form.elements[groupElement].currencyFormat
                          "
                          :openButtons="form.elements[groupElement].EditState"
                          @change="SaveValue($event, groupElement)"
                          @cancel="CancelValue(groupElement)"
                          @Edit="
                            EditData(
                              form.elements[groupElement].ShowEditTextBox,
                              groupElement,
                              form.elements[groupElement].EditEvent,
                              $event
                            )
                          "
                        >
                        </adl-editable-input>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  v-if="form.elements[groupElement].isShowRefresh"
                  :class="$style['range-refreshWrap']"
                >
                  <a
                    :class="$style['my-link']"
                    @click="refreshValue(form.elements[groupElement])"
                    href="#"
                    >{{ form.elements[groupElement].refreshText }}</a
                  >

                  <mds-button
                    variation="icon-only"
                    icon="info-circle"
                    type="button"
                    @mouseover="toggleRangeTT = true"
                    @mouseleave="toggleRangeTT = false"
                    @focus="toggle = true"
                    @blur="toggleRangeTT = false"
                    id="default-trigger-range"
                    size="small"
                  >
                    User
                  </mds-button>

                  <mds-tooltip
                    triggered-by="default-trigger-range"
                    v-model="toggleRangeTT"
                    :position="['right-center']"
                  >
                    {{ form.elements[groupElement].refreshToolTip }}
                  </mds-tooltip>
                </div>
              </div>
              <div
                v-if="form.elements[groupElement].displayType === 'slider'"
                style="margin-top: 10px"
              >
                <div :class="$style['boldfont']">
                  {{ form.elements[groupElement].name }}
                </div>
                <adl-range-slider
                  :data-id="form.elements[groupElement].id"
                  :size="size"
                  :options="form.elements[groupElement].options"
                  lower-label=""
                  :name="form.elements[groupElement].htmlName"
                  :step="form.elements[groupElement].step"
                  :isShowRefreshIcon="
                    form.elements[groupElement].isShowRefreshIcon
                  "
                  v-model="form.elements[groupElement].value"
                  :key="form.elements[groupElement].id"
                  :required="form.elements[groupElement].isRequired"
                  :min="form.elements[groupElement].minValue"
                  :max="form.elements[groupElement].maxValue"
                  :inputMax="form.elements[groupElement].inputMax"
                  :isShowDecimal="form.elements[groupElement].isShowDecimal"
                  :inputFormat="form.elements[groupElement].inputFormat"
                  :isCurrencyFormat="
                    form.elements[groupElement].isCurrencyFormat
                  "
                  :tooltipMessage="form.elements[groupElement].tooltipMessage"
                  :refreshText="form.elements[groupElement].refreshText"
                  :disabled="form.elements[groupElement].isdisabled"
                  :maxlength="
                    form.elements[groupElement].maxlength
                      ? form.elements[groupElement].maxlength
                      : 9
                  "
                  @change="inputChange()"
                  @refresh="refreshValue"
                ></adl-range-slider>
              </div>

              <div
                :class="[$style['dataListGroup'], $style['group-data']]"
                v-if="form.elements[groupElement].displayType === 'radiobutton'"
              >
                <div
                  :class="[
                    $style['radiobtn'],
                    $style['boldfont'],
                    $style['group-data-radio'],
                  ]"
                >
                  <div style="display: flex">
                    <div>
                      {{ form.elements[groupElement].name }}
                    </div>

                    <div v-if="form.elements[groupElement].ShowToolTip">
                      <mds-button
                        variation="icon-only"
                        icon="info-circle"
                        type="button"
                        :id="'default-trigger-range' + groupElement"
                        size="small"
                        :class="$style['tooltip-left']"
                        @mouseover="
                          form.elements[groupElement].ShowToolTipText = true
                        "
                        @mouseleave="
                          form.elements[groupElement].ShowToolTipText = false
                        "
                        @blur="
                          form.elements[groupElement].ShowToolTipText = false
                        "
                      >
                      </mds-button>

                      <mds-tooltip
                        v-model="form.elements[groupElement].ShowToolTipText"
                        :triggered-by="'default-trigger-range' + groupElement"
                      >
                        {{ form.elements[groupElement].TooltipMessage }}
                      </mds-tooltip>
                    </div>
                  </div>
                  <div>
                    <mds-switch
                      hidden-label
                      :data-id="form.elements[groupElement].id"
                      :name="form.elements[groupElement].htmlName"
                      :size="size"
                      v-model="form.elements[groupElement].value"
                      @change="inputChange()"
                      :key="form.elements[groupElement].id"
                    >
                      {{ form.elements[groupElement].name }}
                    </mds-switch>
                  </div>
                </div>
              </div>
            </template>
          </div>
          <div style="text-align: center">
            <mds-icon
              style="padding-top: 20px"
              :name="ExpandIcon()"
              size="small"
              @click.native="Expandclick()"
            />
          </div>
        </mds-fieldset>
      </div>
    </div>
  </nav>
</template>

<style module lang="scss">
@import "@mds/constants";
@import "@mds/typography";
@import "@mds/link";
.tooltip-left {
  padding: $mds-space-half-x 0px 0px $mds-space-half-x !important;
}
.hide-element {
  display: none;
}
.range-refreshWrap {
  margin-top: 10px;
  display: flex;

  .my-link {
    @include mds-link();
    color: $mds-interactive-color-primary-default !important;
    font-size: 14px;
    line-height: 14px;
    border-bottom: 1px solid $mds-interactive-color-primary-default;
    font-weight: 400;
    margin-top: 0px !important;
    float: none !important;
  }
  button {
    margin-left: $mds-space-half-x;
  }
}
.extratag {
}
.group-data-radio {
  margin-bottom: 0px !important;
  // border-bottom: 1px solid #e0e0e0;
  //  padding-bottom: 8px;
  // margin-top: $mds-space-2-x;
}
.group-data {
  border-bottom: 1px solid #e0e0e0;
  padding-bottom: 10px;
  padding-top: 10px;
  // margin-top: $mds-space-2-x;
}
.group-data-img {
  border-bottom: 1px solid #e0e0e0;
  padding-bottom: 25px;
}
.GroupWrap {
  border: $mds-border-separator-on-light;
  padding: $mds-space-4-x $mds-space-2-x;
  border-radius: $mds-space-1-x;
  background-color: $mds-background-color-white;
  margin-top: $mds-space-1-x;
}
.group-data-hide {
  display: none !important;
}
.mca-components-ui__editable-form {
  .mds-card-image {
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .cf-card-image-engagement {
    position: relative;
    padding-left: 56px;

    .mds-card-caption {
      min-width: 100% !important;
      margin-left: 0px !important;
    }
  }

  .cf-card-profileWraper {
    position: absolute;
    left: 0;
  }
  .mds-card-caption {
    min-width: 100% !important;
    margin-left: 0px !important;
  }
  .cf-card-title-engagement {
    @include mds-level-6-heading($bold: true);
    margin-bottom: 0;
    margin-top: 0px;
    font-size: 14px !important;
    overflow: hidden;
    text-overflow: ellipsis;
    word-break: break-all;
    width: 193px;
  }

  .cf-tag-inner {
    min-width: auto;
    font-size: 10px;
    color: #ffffff !important;
    text-transform: uppercase;
    line-height: 20px;
    font-weight: bold;
    letter-spacing: 1.67px;
    margin-left: 8px;
    background-color: #005ba1 !important;
  }
  .dataListEditIcon {
    float: right;
    display: none;
  }
  // .dataListTag {
  //   float: right;
  //   display: block;
  // }

  // .dataListGroup:hover .dataListTag {
  //   display: none;
  // }
  .dataListGroup:hover .dataListEditIcon {
    display: block;
  }
  .radiobtn {
    display: flex;
    justify-content: space-between;
    margin-bottom: 10px;
  }
  .boldfont {
    font-weight: 600;
  }

  font-style: normal;
  font-size: 16px;
  font-weight: 300;
  line-height: 21px;
  color: #1e1e1e;

  .innerlabel {
    font-weight: 300 !important;
  }
  .dataListGroup .edittag {
    display: none;
  }
  .dataListGroup:hover .edittag {
    display: flex;
  }
  .dataListGroup:hover .extratag {
    opacity: 0 !important;
  }
  .cfSet {
    width: 100%;
    float: left;
  }
  .mdsswitch {
    // margin-bottom: 10px;
  }
  .group-section {
    border-top: none;
    //padding-top: $mds-space-2-x;
    margin-top: $mds-space-2-x;
  }

  .group-title {
    @include mds-eyebrow-heading();
    font-size: $mds-space-inset-s !important;
    margin-bottom: $mds-space-1-x;
  }
  .my-link {
    @include mds-link();
    color: $mds-interactive-color-primary-default !important;
    float: right;
    margin-top: 30px;
    font-size: 14px;
    line-height: 16px;
    border-bottom: 1px solid $mds-interactive-color-primary-default;
  }
  .mds-range-slider .mds-range-slider__input {
    flex: 0 0 50%;
  }
  .loader {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: hsla(0, 100%, 0%, 0.2);

    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    text-align: center;

    h6 {
      @include mds-eyebrow-heading;
    }
  }

  .mds-form--medium-layout {
    .mds-label {
      margin-bottom: $mds-space-2-x;
    }

    .mds-range-slider {
      margin-bottom: $mds-space-2-x;
      &:last-child {
        margin-bottom: 0px;
      }
      .mds-label {
        margin-bottom: 0px !important;
      }
    }
  }
}
</style>
